export default __webpack_public_path__ + "static/media/36I-102692_-15645_0.7c7d8037.jpg";